<template>
  <user-form>
    <ButtonCreate class="mt_m"/>
  </user-form>
</template>

<script>
import UserForm from '@/components/User/Form'
import ButtonCreate from '@/components/User/ButtonCreate'

export default {
  components: {
    UserForm,
    ButtonCreate
  },
  created: async function () {
    this.$store.dispatch('user/resetForm')
  }
}
</script>
